import aegis from "../../../../src/images/aegis.png";
import caster from "../../../../src/images/caster.png";
import ccore from "../../../../src/images/ccore.png";
import fiq from "../../../../src/images/fiq.png";
import search from "../../../../src/images/search.png";
import artc from "../../../../src/images/artc.png";
import alphago from "../../../../src/images/alphago.png";
import score from "../../../../src/images/score.png";
import emma from "../../../../src/images/emma.png";
import ernie from "../../../../src/images/ernie.png";
import cps from "../../../../src/images/cps.png";
import blue_prism from "../../../../src/images/blue_prism.png";
import aware from "../../../../src/images/aware.png";
import griffeye from "../../../../src/images/griffeye.png";
import pha from "../../../../src/images/pha.png";
import ccl from "../../../../src/images/ccl.png";
import thermal from "../../../../src/images/thermal.jpg";
import * as React from 'react';
export default {
  aegis,
  caster,
  ccore,
  fiq,
  search,
  artc,
  alphago,
  score,
  emma,
  ernie,
  cps,
  blue_prism,
  aware,
  griffeye,
  pha,
  ccl,
  thermal,
  React
};